import { useLang, translations } from "../i18n";

export function Navbar() {
  const { lang, toggle } = useLang();
  const t = translations.nav;

  return (
    <nav className="relative z-10 flex justify-between items-center px-6 md:px-12 py-6 max-w-7xl mx-auto w-full">
      <a href="/" className="text-lg font-extrabold tracking-tight text-white">
        Vilverin<span className="text-[var(--primary)]">.</span>
      </a>
      <div className="flex items-center gap-6">
        <a href="#how-it-works" className="hidden sm:inline text-[13px] font-medium text-white/40 hover:text-white/60 transition-colors">
          {t.howItWorks[lang]}
        </a>
        <a href="#pricing" className="hidden sm:inline text-[13px] font-medium text-white/40 hover:text-white/60 transition-colors">
          {t.pricing[lang]}
        </a>
        <button
          onClick={toggle}
          className="hidden sm:inline text-[13px] font-medium text-white/40 hover:text-white/60 transition-colors cursor-pointer"
        >
          {lang === "en" ? "PT" : "EN"}
        </button>
        <a
          href="#waitlist"
          className="text-[13px] font-medium text-white/80 hover:text-white transition-colors px-4 py-2 border border-white/10 rounded-lg hover:border-white/20"
        >
          {t.requestAccess[lang]}
        </a>
      </div>
    </nav>
  );
}
